<template>
	<div :class="['faq--question', {'faq--question-show-content': showContent}]">
		<div class="faq--question-icon">
			<Icon icon="question-mark"/>
		</div>
		<div class="faq--question-title">
			<a href="#" @click.prevent="showContent = !showContent">
				<div class="faq--question-title-text">{{ title }}</div>
			</a>
		</div>
		<div v-if="showContent" class="faq--question-content">
			<slot/>
			<div class="faq--question-feedback">
				<div v-if="gaveFeedback" class="success">Vielen Dank!</div>
				<template v-else>
					<div>
						War diese Antwort hilfreich?
					</div>
					<div class="faq--question-feedback-buttons">
						<div>
							<Button text="Ja" smaller secondary @click="feedback(true)"/>
						</div>
						<div>
							<Button text="Nein" smaller secondary @click="feedback(false)"/>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import Button from "@/vue/common/Button.vue";
import {FAQ_FEEDBACK, push} from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {
	components: {Button, Icon},

	props: {
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			showContent: false,
			gaveFeedback: false
		};
	},

	methods: {
		feedback (positive)
		{
			push(
				new EventData()
					.setEvent(FAQ_FEEDBACK)
					.setAction(positive ? 'Hilfreich' : 'Nicht hilfreich')
					.setName(this.title)
			);

			this.gaveFeedback = true;
		}
	}
}
</script>
